import { useEffect, useMemo, useState } from 'react';
import { clsx } from 'clsx';
import arrowTop from '@web/utils/src/assets/icons/functions/arrow-top.svg';
import { Taxonomy } from '@/types';

interface CategoryFilterItemProps {
  category: Taxonomy;
  activeCategory: Taxonomy | undefined;
  className?: string;
  hasParent?: boolean;
  handleTaxonomySelection: (category: Taxonomy) => void;
}

const CategoryFilterItem = (props: CategoryFilterItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { handleTaxonomySelection, category, className, activeCategory } =
    props;

  useEffect(() => {
    if (!activeCategory) return;
    if (activeCategory.parentId == category.id) {
      setIsOpen(true);
    } else {
      // setIsOpen(false);
    }
    if (activeCategory.id === category.id && activeCategory.children) {
      setIsOpen(true);
    }
  }, [activeCategory, category]);

  // class name
  const TaxonomyClassName = useMemo(() => {
    const active =
      (activeCategory && activeCategory.id === category.id) || isOpen;

    return `text-1-4 ${active ? 'font-bd' : ''}`;
  }, [category, activeCategory, isOpen]);

  return (
    <>
      <div
        className={clsx(className, 'flex items-center mb-0-6 cursor-pointer')}
        onClick={() => {
          handleTaxonomySelection(category);
        }}
      >
        <div className="relative">
          {category.children && category?.children.length > 0 && (
            <img
              src={arrowTop}
              className={clsx(
                isOpen ? 'rotate-180' : 'rotate-90',
                'absolute w-0-9 h-0-9 -left-1-5 top-0-6 transform',
              )}
              alt="selected"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            />
          )}
          <p className={TaxonomyClassName}>{category.name}</p>
        </div>
      </div>
      {category.children &&
        isOpen &&
        category.children.map(
          (child) =>
            child && (
              <div
                className={clsx(isOpen ? 'block' : 'hidden', 'pl-1-5')}
                key={child.id}
              >
                <CategoryFilterItem
                  category={child}
                  activeCategory={activeCategory}
                  handleTaxonomySelection={handleTaxonomySelection}
                />
              </div>
            ),
        )}
    </>
  );
};

export default CategoryFilterItem;
